// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { QuickTree } from '../elements/QuickTree/QuickTree';
import { KeyEventProcessor } from '@shared/commons/KeyEventProcessor';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class QuickTreeReactProps {
}
export class QuickTreeReactComponentView {
}
export class QuickTreeReactViewModel extends AbstractViewModel {
    get width() {
        return this.componentView.width;
    }
    set width(value) {
        this.updateComponentView('width', value);
        this.quickTree.width = value;
    }
    get height() {
        return this.componentView.height;
    }
    set height(value) {
        this.updateComponentView('height', value);
        this.quickTree.height = value;
    }
    constructor() {
        super(QuickTreeReactComponentView);
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        const keyProc = KeyEventProcessor;
        keyProc.OnKeyDown.Subscribe(this.onGlobalKeyDown, this);
        keyProc.OnKeyUp.Subscribe(this.onGlobalKeyUp, this);
    }
    update(props) {
        super.update(props);
        let isNeedRedraw = false;
        if (props.isMultiSelect !== this.props.isMultiSelect) {
            this.setIsMultiSelect(props.isMultiSelect, props.UseCHBox);
            isNeedRedraw = true;
        }
        if (isNeedRedraw) {
            this.quickTree.Draw();
        }
    }
    dispose() {
        const keyProc = KeyEventProcessor;
        keyProc.OnKeyDown.UnSubscribe(this.onGlobalKeyDown, this);
        keyProc.OnKeyUp.UnSubscribe(this.onGlobalKeyUp, this);
        super.dispose();
    }
    createQuickTree(ctx) {
        this.quickTree = new QuickTree(ctx);
        this.quickTree.showTooltip = (text, rect) => {
            showTooltipOnCanvas(text, ctx.canvas, rect);
        };
        this.quickTree.boldRootNode = this.props.boldRootNode;
        this.quickTree.isMultiSelect = false;
        this.quickTree.SelectionChanged.Subscribe(this.onSelectionChanged, this);
        this.quickTree.EnterPressed.Subscribe(this.onEnterPressed, this);
        this.setIsMultiSelect(this.props.isMultiSelect, this.props.UseCHBox);
        this.props.onQuickTreeCreated(this.quickTree);
    }
    setSizes(w, h) {
        this.width = w;
        this.height = h;
        this.quickTree.onResize();
    }
    resetSizes() {
        this.setSizes(0, 0);
    }
    setContextScale(devicePixelRatio) {
        this.quickTree.DrawingContext.scale(devicePixelRatio, devicePixelRatio);
    }
    onEnterPressed() {
        this.props.onEnterPress(this.quickTree);
    }
    onSelectionChanged() {
        this.props.onSelection(this.quickTree);
    }
    onMouseDown(event) {
        this.quickTree.onMouseDown(event.nativeEvent);
        ControlsUtils.Capture.SetCapture(this, event.nativeEvent);
        this.props.onAfterMouseDown();
    }
    onMouseMove(event) {
        var _a, _b;
        const nativeEvent = (_b = (_a = event.nativeEvent) !== null && _a !== void 0 ? _a : event.originalEvent) !== null && _b !== void 0 ? _b : event;
        this.quickTree.onMouseMove(nativeEvent);
    }
    onMouseUp(event) {
        this.quickTree.onMouseUp(event.nativeEvent);
    }
    onMouseWheel(event) {
        this.quickTree.onMouseWheel(event.nativeEvent);
    }
    onDoubleClick(event) {
        // if (this.quickTree.isMultiSelect)   //  https://tp.traderevolution.com/entity/84756  (2nd issue)
        //  return;
        const res = this.quickTree.onDoubleClick(event.nativeEvent);
        if (res) {
            this.props.onDoubleClick(this.quickTree);
        }
    }
    onMouseLeave(event) {
        this.quickTree.onMouseLeave(event.nativeEvent);
    }
    onGlobalKeyDown() {
        // const container = this.get('parentContainerControl');
        // if (container?.get('focused') || this.get('focused')) {
        this.quickTree.onKeyDown();
        this.props.onKeyDown();
        // }
    }
    onGlobalKeyUp() {
        // const container = this.get('parentContainerControl');
        // if (container?.get('focused') || this.get('focused')) {
        this.quickTree.onKeyUp();
        // }
    }
    setIsMultiSelect(isMultiSelect, userCHBox) {
        if (userCHBox) {
            this.quickTree.isMultiSelectCheckboxUsing = isMultiSelect;
        }
        else {
            this.quickTree.isMultiSelect = isMultiSelect;
        }
    }
}
